module.exports = __webpack_public_path__ + "img/altegio.dbca63bd.png";